import { Chart, PieChart } from 'devextreme-react';
import { Connector, Format, Label, Legend, Series, Tooltip } from 'devextreme-react/chart';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useEffect, useState } from 'react';
import reportService from '@/projects/platform/services/report-service';

export default function TotalSalesByMarket(props: any) {
    var params: string;
    const { retailerId, startDate, endDate } = props;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    function filter() {
        params = '';
        for (const key of Object.keys(props)) {
            if (props[key]) {
                params += `${key}=${props[key]}&`;
            }
        }
        params = params.slice(0, -1);
    }
    function customizeTooltip(arg: any) {
        return {
            text: `${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`,
        };
    }
    useEffect(() => {
        setLoading(true);
        filter();
        reportService.getTotalSalesByMarket(params)
            .then((response) => {
                setDataSource(response.data.searchResult.reverse());
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                throw new Error('Data Loading Error');
            });
    }, [retailerId, startDate, endDate]);

    return (
        <>
            <LoadIndicator visible={loading} />
            <PieChart
                id="pie"
                type="doughnut"
                title="Total Sales By Market"
                palette="Soft Pastel"
                dataSource={dataSource}
            >
                <Series argumentField="market">
                    <Label visible={true} format="largeNumber">
                        <Connector visible={true} />
                    </Label>
                </Series>
                <Legend
                    margin={0}
                    horizontalAlignment="right"
                    verticalAlignment="top"
                />
                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                    <Format type="largeNumber" />
                </Tooltip>
            </PieChart>
        </>
    );
}